const MAX_UPLOAD_BYTES = 720_000

export async function prepareBackground(file: File): Promise<string> {
  if (
    !['image/png', 'image/jpeg', 'image/webp'].includes(file.type) ||
    file.size > 10 * 1024 * 1024
  )
    throw new Error('invalid-image')
  const image = await createImageBitmap(file)
  try {
    if (image.width * image.height > 36_000_000) throw new Error('invalid-image')
    const ratio = Math.min(1, 1920 / Math.max(image.width, image.height))
    const canvas = document.createElement('canvas')
    canvas.width = Math.max(1, Math.round(image.width * ratio))
    canvas.height = Math.max(1, Math.round(image.height * ratio))
    const context = canvas.getContext('2d')
    if (!context) throw new Error('invalid-image')
    context.fillStyle = '#ffffff'
    context.fillRect(0, 0, canvas.width, canvas.height)
    context.drawImage(image, 0, 0, canvas.width, canvas.height)
    for (const quality of [0.86, 0.72, 0.56, 0.4]) {
      const blob = await new Promise<Blob | null>((resolve) =>
        canvas.toBlob(resolve, 'image/webp', quality),
      )
      if (blob && blob.size <= MAX_UPLOAD_BYTES) {
        return await new Promise<string>((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => resolve(String(reader.result).split(',')[1] || '')
          reader.onerror = () => reject(new Error('invalid-image'))
          reader.readAsDataURL(blob)
        })
      }
    }
    throw new Error('image-too-large')
  } finally {
    image.close()
  }
}
